import React from 'react';
import { Navbar, Container } from 'react-bootstrap';
import LanguageSelector from './LanguageSelector';

function Header() {
  return (
    <>
      <Navbar expand="lg" style={{ backgroundColor: 'transparent' }}>
        <Container>
          <Navbar.Brand href="#home">
            <img
              src="./logo.svg" // Replace with your logo path
              alt="Logo"
              width="170"
              height="65"
              style={{ marginTop: '20px' }}
              className="d-inline-block align-top imageLogo"
            />{' '}
          </Navbar.Brand>
          <div className="ml-auto">
            {' '}
            {/* Aligns the LanguageSelector to the right */}
            <LanguageSelector />
          </div>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
